<div #algoEntry class="order-entry__screen-order__body oe-algo-entry">
  <!-- CLIENT -->
  <div #panelClient class="order-entry__panel-client-details__container">
    <div class="order-entry__panel-order-details__row">
      <ic-autocomplete
        class="order-entry__panel-client-details__data-client"
        #inputClient
        mode="client"
        [disabled]="data.client.disabled"
        [constraintAutoSelect]="control.clientAccountConstraintAutoSelect"
        [(ngModel)]="data.client.value"
        (ngModelChange)="onClientChange($event)"
        [externalState]="data.client.externalState"
        (onClientSelect)="onClientSelect($event)"
        [entryType]="entryType"
        [fieldsGroup]="true"
      >
      </ic-autocomplete>
    </div>
    <div class="order-entry__panel-order-details__row">
      <ic-autocomplete
        class="order-entry__panel-client-details__data-account"
        #inputAccount
        mode="account"
        [disabled]="data.account.disabled"
        [constraint]="data.client.value"
        [constraintAutoSelect]="control.clientAccountConstraintAutoSelect"
        [(ngModel)]="data.account.value"
        (ngModelChange)="onAccountChange($event)"
        [externalState]="data.account.externalState"
        [entryType]="entryType"
        [fieldsGroup]="true"
      >
      </ic-autocomplete>
    </div>

    <div class="order-entry__panel-order-details__row">
      <bfx-contacts-input
        #inputContacts
        [ngClass]="{
          'order-entry__panel-client-details__data-contacts': true,
          'order-entry__panel-client-details__data-contacts--full-size': true
        }"
        [client]="data.client.value"
        [label]="data.contacts.label"
        [disabled]="data.clientTrader.disabled"
        [selectedTrader]="data.clientTrader.value"
        [(ngModel)]="data.contacts.value"
        (contactChanged)="onContactsChange($event)"
        [externalState]="data.contacts.externalState"
        (traderChanged)="onClientTraderUpdate($event)"
        (commentsChanged)="onClientDefaultCommentsChanged($event)"
        (contactManagerOpen)="onContactManagerOpen($event)"
        (contactManagerClosed)="onContactManagerClosed($event)"
        [fieldsGroup]="true"
      >
      </bfx-contacts-input>
    </div>
    <div class="order-entry__panel-order-details__row">
      <ic-autocomplete
        *ngIf="data.clientTrader.enabled"
        class="order-entry__panel-client-details__client-trader"
        #inputClientTrader
        mode="client_trader"
        [label]="data.clientTrader.label"
        [disabled]="data.clientTrader.disabled"
        [constraint]="data.client.value"
        [(ngModel)]="data.clientTrader.value"
        (ngModelChange)="onClientTraderChange($event)"
        [externalState]="data.clientTrader.externalState"
        [entryType]="entryType"
        [fieldsGroup]="true"
      >
      </ic-autocomplete>
    </div>

    <!-- OBO *ngIf="oboEnabled" -->
    <div *ngIf="false" class="order-entry__panel-obo__container">
      <div class="order-entry__panel-obo__row">
        <bfx-text-input
          #oboClient
          class="order-entry__panel-obo__input"
          [(ngModel)]="data.oboClient.value"
          [disabled]="data.oboClient.disabled"
          [size]="'sm'"
          [inputLabelText]="'OBO Client'"
          type="search"
          autocomplete="off"
          maxlength="255"
          (ngModelChange)="updateOBOClient($event)"
        ></bfx-text-input>
      </div>
      <div class="order-entry__panel-obo__row">
        <bfx-text-input
          #oboAccount
          class="order-entry__panel-obo__input"
          [(ngModel)]="data.oboAccount.value"
          [inputLabelText]="'OBO Account'"
          [disabled]="data.oboClient.disabled"
          [size]="'sm'"
          type="search"
          autocomplete="off"
          maxlength="255"
          (ngModelChange)="updateOBOAccount($event)"
        ></bfx-text-input>
      </div>
    </div>

    <!-- TABS -->
    <p-tabView
      class="order-entry__screen-order__tab-view"
      styleClass="bfx-tabview"
      [activeIndex]="tabIndex"
      (onChange)="onTabActivate($event)"
      #tabs
    >
      <p-tabPanel
        class="order-entry__panel-financials__tab-panel"
        [header]="tabData.financials.label"
      >
        <!-- FINANCIALS -->
        <div #panelFinancials class="order-entry__panel-financials__container">
          <div class="order-entry__panel-financials__row">
            <ic-ccy-pair-string
              #inputCcyPair
              class="order-entry__panel-financials__ccy-pair"
              [entryType]="entryType"
              [label]="data.currencyPair.label"
              [dataset]="data.currencyPair.dataset"
              [inverted]="data.currencyPair.inverted"
              [(ngModel)]="data.currencyPair.product"
              (blur)="onCcyPairBlur($event)"
              [externalState]="data.currencyPair.externalState"
            >
            </ic-ccy-pair-string>
            <ic-algo-type
              #inputAlgoType
              class="order-entry__panel-financials__order-type"
              [label]="data.algoType.label"
              [disabled]="data.algoType.disabled"
              [dataset]="data.algoType.dataset"
              [(ngModel)]="data.algoType.value"
              (onBlur)="onAlgoTypeChange($event)"
              (onSelect)="onAlgoTypeChange($event)"
              [externalState]="data.algoType.externalState"
              [entryType]="entryType"
            >
            </ic-algo-type>
          </div>

          <div
            class="order-entry__panel-financials__row"
            [style.display]="!control.showIntentAndAmount?'none':'flex'"
          >
            <div class="order-entry__panel-financials__client-intent-container">
              <bfx-client-intent-toggle
                #toggleClientIntent
                class="order-entry__panel-financials__client-intent"
                [label]="data.clientIntent.label"
                [(ngModel)]="data.clientIntent.value"
                (ngModelChange)="onClientIntentToggleChange($event)"
                [externalState]="data.clientIntent.externalState"
              >
              </bfx-client-intent-toggle>
              <ic-fixed-ccy
                #toggleFixedCcy
                class="order-entry__panel-financials__fixed-ccy"
                [ccyPair]="data.fixedCcy.ccyPair"
                [(ngModel)]="data.fixedCcy.value"
                (ngModelChange)="onFixedCcyToggleChange($event)"
              >
              </ic-fixed-ccy>
            </div>
            <bfx-amount-spinner
              #inputOrderAmount
              class="order-entry__panel-financials__order-amount"
              [label]="data.orderAmount.label"
              [currency]="data.fixedCcy.fixedCcy"
              [(ngModel)]="data.orderAmount.value"
              (ngModelChange)="onOrderAmountChange($event)"
              (blur)="onOrderAmountBlur($event)"
              [externalState]="data.orderAmount.externalState"
              [size]="'sm'"
            >
            </bfx-amount-spinner>
          </div>
          <div class="order-entry__panel-financials__row">
            <bfx-markup
              #inputMarkup
              class="order-entry__panel-financials__data-markup"
              [label]="data.markup.label"
              [pair]="data.currencyPair.model"
              [isInvert]="data.currencyPair.inverted"
              [markupCriteria]="data.markup.criteria"
              [style.display]="data.markup.config.markupEnabled ? 'flex': 'none'"
              [disabled]="data.markup.disabled || !data.markup.config.markupEntry"
              [retrieveEnabled]="data.markup.retrieveEnabled"
              [(ngModel)]="data.markup.value"
              [(trackingRate)]="data.trackingRate.textValue"
              (ngModelChange)="onMarkupChange($event)"
              (onGetMarkupCriteria)="onGetMarkupCriteria($event)"
              (onMarkupCheckboxState)="onMarkupCheckboxState($event)"
              [externalState]="data.markup.externalState"
            >
            </bfx-markup>
            @if(isNDFAlgo){
            <bfx-ndf-value-date
              class="order-entry__panel-financials__value-date"
              #inputValueDate
              [ngClass]="inputValueDate.classes"
              [label]="data.valueDate.label"
              scrollHeight="120px"
              [entryType]="entryType"
              [disabled]="data.valueDate.disabled"
              [(ngModel)]="data.valueDate.value"
              [(dataset)]="data.valueDate.dataset"
              (ngModelChange)="onValueDateChange($event)"
              [externalState]="data.valueDate.externalState"
              [ndf1MOnlyOverride]="true"
            >
            </bfx-ndf-value-date>
            } @else{
            <bfx-value-date
              class="order-entry__panel-financials__value-date"
              #inputValueDate
              [ngClass]="inputValueDate.classes"
              [label]="data.valueDate.label"
              scrollHeight="120px"
              [entryType]="entryType"
              [disabled]="data.valueDate.disabled"
              [(ngModel)]="data.valueDate.value"
              [(dataset)]="data.valueDate.dataset"
              (ngModelChange)="onValueDateChange($event)"
              [externalState]="data.valueDate.externalState"
            >
            </bfx-value-date>
            }
          </div>
          <div class="order-entry__panel-financials__row"></div>
        </div>
        <hr class="oe__panel__hr" />
        <!-- ALGO STRATEGY PARAMETERS PANEL  -->
        <div
          class="order-entry__panel-financials__algo__pane"
          [style.display]="data.algoType.value == null || data.algoType.value.value == null ? 'none':'flex'"
        >
          <oe-panel-algo-params
            #panelAlgoParams
            [refId]="refId"
            [rootRefId]="rootRefId"
            [entryType]="entryType"
            [algoType]="data.algoType.value"
            [ccyCode]="data.fixedCcy.fixedCcy"
            [orderAmt]="data.orderAmount.value"
            [(limitPrice)]="data.limitPrice.value"
            (limitPriceChange)="onLimitPriceChange(data.limitPrice.value)"
            [ccyPairCode]="data.currencyPair.product"
            [ccyPairInverted]="data.currencyPair.inverted"
            [rate]="rate.value"
            (error)="handleAlgoParamsError($event)"
          >
          </oe-panel-algo-params>
        </div>
        <!-- PANE DUE -->
        <hr class="oe__panel__hr" />
        <div class="order-entry__panel-good-from-until__row">
          <bfx-good-from-until
            #inputGoodFrom
            [mode]="data.goodFrom.mode"
            [isAlgo]="true"
            class="input-good-from order-entry__panel-financials__good-from"
            panelStyleClass="order-entry__panel-financials__goodfrom-calendar"
            [disabled]="data.goodFrom.locked"
            [label]="data.goodFrom.label"
            [placeholder]="data.goodFrom.placeholder"
            [(ngModel)]="data.goodFrom.value"
            [constraint]="data.goodUntil.value"
            [externalState]="data.goodFrom.externalState"
            [errorMsg]="data.goodFrom.errorMsg"
            [tooltipLabel]="data.goodFrom.tooltip"
            (ngModelChange)="onGoodFromChange()"
          >
          </bfx-good-from-until>
        </div>
        <div class="order-entry__panel-good-from-until__row">
          <bfx-good-from-until
            #inputGoodUntil
            [mode]="data.goodUntil.mode"
            [isAlgo]="true"
            class="input-good-until order-entry__panel-financials__good-until"
            panelStyleClass="order-entry__panel-financials__gooduntil-calendar"
            [label]="data.goodUntil.label"
            [placeholder]="data.goodUntil.placeholder"
            [disabled]="data.goodUntil.locked"
            [(ngModel)]="data.goodUntil.value"
            [constraint]="data.goodFrom.value"
            [externalState]="data.goodUntil.externalState"
            [errorMsg]="data.goodUntil.errorMsg"
            [tooltipLabel]="data.goodUntil.tooltip"
            (ngModelChange)="onGoodUntilChange()"
          >
          </bfx-good-from-until>
        </div>

        <div class="order-entry__panel-financials__row">
          <!-- SUSPEND -->
          <bfx-suspend-control
            #inputSuspend
            class="order-entry__panel-financials__data-suspend"
            [style.display]="data.suspend.show ? 'flex': 'none'"
            [labelFrom]="data.suspend.from.label"
            [labelTo]="data.suspend.to.label"
            [externalState]="data.suspend.externalState"
            [(ngModel)]="data.suspend.value"
            (ngModelChange)="onSuspendChange($event)"
          >
          </bfx-suspend-control>
          <!-- HOLD STP -->
          <ic-hold-stp
            class="order-entry__panel-more__cell"
            #inputHoldSTP
            [label]="data.holdSTP.label"
            [config]="data.holdSTP.enabledConfig"
            [loading]="control.isLoading"
            [client]="data.client.value"
            [account]="data.account.value"
            [(ngModel)]="data.holdSTP.value"
            (ngModelChange)="onHoldSTPChange()"
          >
          </ic-hold-stp>
          <!-- TRADER GROUP -->
          <bfx-autoComplete
            id="oe-control_trader-group"
            #inputTraderGroup
            class="order-entry__panel-financials__trader-group"
            [useAlternateBlur]="true"
            [alternateConfig]="control.traderGroupAutocompleteConfig"
            [emptyIsInactive]="true"
            nativeDesktopDropdown="traderGroup"
            target="traderGroup"
            [state]="!data.traderGroup.traderGroupModifiable||data.traderGroup.locked ? 3 : data.traderGroup.state"
            [disabled]="!data.traderGroup.traderGroupModifiable||data.traderGroup.locked"
            inputId="trader-input"
            [(ngModel)]="data.traderGroup.value"
            [suggestions]="data.traderGroup.traderGroups"
            (completeMethod)="searchTraderGroup($event)"
            (onFocus)="traderGroupFocus()"
            (onSelect)="onSelectTraderGroup($event)"
            (onBlur)="onSelectTraderGroup($event)"
            [dropdown]="true"
            delay="5"
            field="groupCode"
            dataKey="groupId"
            [label]="data.traderGroup.label"
            [minLength]="0"
            [maxlength]="50"
            [appendTo]="'body'"
            [size]="'sm'"
          >
          </bfx-autoComplete>
        </div>
      </p-tabPanel>
      <p-tabPanel [header]="tabData.more.label" class="order-entry__panel-financials__more-panel">
        <!-- MORE -->
        <div class="order-entry__panel-more__container">
          <!-- PANE UNO -->
          <div class="order-entry__panel-more__comments">
            <!-- CLIENT COMMENT -->
            <div class="order-entry__panel-more__comments-client__container">
              <div class="order-entry__panel-more__comments-client__row">
                <p-checkbox
                  *ngIf="data.commentClient.checkbox.show"
                  [bfxInputLabelOnClick]="commentClientLabel"
                  [ngClass]="{
                    'bfx-checkbox-enable-control': true,
                    'order-entry__panel-more__comments-client__checkbox': true,
                    'order-entry__panel-more__comments-client__checkbox--checked': data.commentClient.checkbox.value && !data.commentClient.locked,
                    'order-entry__panel-more__comments-client__checkbox--unchecked': !data.commentClient.checkbox.value && !data.commentClient.locked,
                    'order-entry__panel-more__comments-client__checkbox--locked': data.commentClient.locked
                  }"
                  binary="true"
                  [(ngModel)]="data.commentClient.checkbox.value"
                  [disabled]="data.commentClient.locked"
                  (ngModelChange)="onCommentClientCheckboxChange()"
                ></p-checkbox>
                <div
                  [ngClass]="{
                    'bfx-input-label': true,
                    'bfx-input-label-sm-bold': true,
                    'bfx-input-label-invalid': this.data.commentClient.externalState == 1 && !data.commentClient.locked,
                    'bfx-input-label-disabled':data.commentClient.locked || this.data.commentClient.externalState == 1,
                    'bfx-input-label-enabled': !(data.commentClient.locked || this.data.commentClient.externalState == 1),
                  }"
                  #commentClientLabel
                >
                  {{data.commentClient.label}}
                </div>
              </div>
              <div class="order-entry__panel-more__comments-client__row">
                <textarea
                  [rows]="hasCustomFields?2:4"
                  pInputTextarea
                  #inputCommentClient
                  [ngClass]="{
                    'order-entry__panel-more__comments__textarea': true,
                    'order-entry__panel-more__comments-client__input': true,
                    'order-entry__panel-more__comments-client__input--invalid': this.data.commentClient.externalState == 1 && !data.commentClient.locked,
                    'order-entry__panel-more__comments-client__input--active': (data.commentClient.checkbox.show && data.commentClient.checkbox.value && !data.commentClient.locked) || (!data.commentClient.checkbox.show && !data.commentClient.locked),
                    'order-entry__panel-more__comments-client__input--inactive': !(this.data.commentClient.externalState == 1 && !data.commentClient.locked) && (data.commentClient.checkbox.show && !data.commentClient.checkbox.value || data.commentClient.locked) || (!data.commentClient.checkbox.show && data.commentClient.locked)
                  }"
                  [(ngModel)]="data.commentClient.value"
                  (ngModelChange)="onContactManagerClosed($event)"
                  [maxlength]="control.commentSize"
                  [disabled]="data.commentClient.locked || (data.commentClient.checkbox.show && !data.commentClient.checkbox.value)"
                  (onFocus)="$event.target.select()"
                  (blur)="onCommentClientChange();"
                ></textarea>
              </div>
            </div>
            <bfx-comment-warning></bfx-comment-warning>
            <!-- PRIVATE COMMENT -->
            <div
              *ngIf="data.commentPrivate.show"
              class="order-entry__panel-more__comments-private__container"
            >
              <div class="order-entry__panel-more__comments-private__row">
                <div
                  [ngClass]="{
                    'bfx-input-label': true,
                    'bfx-input-label-sm-bold': true,
                    'bfx-input-label-disabled':data.commentPrivate.locked,
                    'bfx-input-label-enabled': !(data.commentPrivate.locked),
                  }"
                  class="order-entry__panel-more__comments-private__label"
                >
                  {{data.commentPrivate.label}}
                </div>
              </div>
              <div class="order-entry__panel-more__comments-private__row">
                <textarea
                  [rows]="hasCustomFields?2:4"
                  pInputTextarea
                  [ngClass]="{
                  'order-entry__panel-more__comments__textarea': true,
                  'order-entry__panel-more__comments-private__input': true,
                  'order-entry__panel-more__comments-private__input--active': !data.commentPrivate.locked,
                  'order-entry__panel-more__comments-private__input--inactive': data.commentPrivate.locked
                }"
                  [(ngModel)]="data.commentPrivate.value"
                  (ngModelChange)="onContactManagerClosed($event)"
                  [maxlength]="control.commentSize"
                  [disabled]="data.commentPrivate.locked"
                  (focus)="$event.target.select()"
                  (blur)="onCommentPrivateChange();"
                ></textarea>
              </div>
            </div>
            <bfx-comment-warning *ngIf="data.commentPrivate.show"></bfx-comment-warning>
          </div>
          <hr class="oe__panel__hr" />
          <!-- PANE DUE -->
          <div class="order-entry__panel-more__extras">
            <div class="order-entry__panel-more__row">
              <!-- PRIVATE ORDER -->
              <ic-private-order
                class="order-entry__panel-more__cell"
                [ngStyle]="{
                  'visibility': data.privateOrder.show  ? 'visible': 'hidden'
                }"
                #inputPrivateOrder
                [loading]="control.isLoading"
                [label]="data.privateOrder.label"
                [(ngModel)]="data.privateOrder.value"
                (ngModelChange)="onPrivateOrderChange()"
              >
              </ic-private-order>
            </div>
            <div
              class="order-entry__panel-more__row"
              [ngStyle]="{
                'display':  data.autoFwdPricing.show ? 'flex': 'none'
              }"
            >
              <!-- AUTO FORWARD ROLL -->
              <ic-auto-fwd-pricing
                class="order-entry__panel-more__cell"
                #autoFwdPricing
                [enabledConfig]="data.autoFwdPricing.enabledConfig"
                [manualOnly]="data.autoFwdPricing.manualOnly"
                [isLoading]="control.isLoading"
                [clientId]="null == data.client.value ? null : data.client.value.clientId"
                [clientAutoFwdType]="null == data.client.value ? null : data.client.value.algoForwardPricing"
                [valueDate]="data.valueDate.value"
                [product]="null"
                [label]="data.autoFwdPricing.label"
                [(ngModel)]="data.autoFwdPricing.value"
                (ngModelChange)="onAutoFwdPricingChange()"
              >
              </ic-auto-fwd-pricing>
            </div>
          </div>
          <hr class="oe__panel__hr" />
          <!-- MORE Custom Fields -->
          <div *ngIf="hasCustomFields" class="order-entry__panel-more__custom-fields">
            <div class="order-entry__panel-more__custom-fields__container">
              <ic-custom-fields
                #customFieldComponent
                [operationMode]="operationMode"
                (valuesChanged)="onCustomValuesChange($event)"
                [externalState]="data.customValues.externalState"
              ></ic-custom-fields>
            </div>
          </div>
        </div>
      </p-tabPanel>
    </p-tabView>
  </div>
</div>
